import { Stack } from '@mui/material'
import CompleteBox from './CompleteBox/CompleteBox'
import { useEffect } from 'react'
import { autorun, runInAction } from 'mobx'
import StoreAchievement from '../StoreAchievement'
import { observer, useLocalObservable } from 'mobx-react-lite'

const CompleteBoxes = observer(() => {
    const localObserver = useLocalObservable(() => ({
        pvPoint: 0,
        tvPoint: 0,
        afpPoint: 0,
        leg1Point: 0,
        leg2Point: 0,
        leg3Point: 0
    }))

    useEffect(() => {
        const disposer = autorun(() => {
            const achievements = StoreAchievement.getAchievements()[StoreAchievement.getSelectedPeriod()]

            if (achievements) {
                achievements.value?.forEach(item => {
                    if (item.achievement.rankShort === StoreAchievement.getSelectedRank()) {
                        const pv = item.metrics.find(metric => metric.name === 'pv')
                        const tv = item.metrics.find(metric => metric.name === 'tv')
                        const afp = item.metrics.find(metric => metric.name === 'ov_apt1')

                        const leg1 = item.metrics.find(metric => metric.name === 'ov_leg1')
                        if (!leg1) {
                            localObserver.leg1Point = -1
                        } else {
                            localObserver.leg1Point = Math.trunc(Math.min(Math.max((leg1.value * 100) / leg1.requiredValue, 0), 100))
                        }

                        const leg2 = item.metrics.find(metric => metric.name === 'ov_leg2')
                        if (!leg2) {
                            localObserver.leg2Point = -1
                        } else {
                            localObserver.leg2Point = Math.trunc(Math.min(Math.max((leg2.value * 100) / leg2.requiredValue, 0), 100))
                        }

                        const leg3 = item.metrics.find(metric => metric.name === 'ov_leg3hc_pv_excluded')
                        if (!leg3) {
                            localObserver.leg3Point = -1
                        } else {
                            localObserver.leg3Point = Math.trunc(Math.min(Math.max((leg3.value * 100) / leg3.requiredValue, 0), 100))
                        }

                        runInAction(() => {
                            if (pv) {
                                localObserver.pvPoint = Math.trunc(Math.min(Math.max((pv.value * 100) / pv.requiredValue, 0), 100))
                                if (localObserver.pvPoint >= 100) {
                                    localObserver.pvPoint = 100
                                } else {
                                    localObserver.pvPoint = Math.floor(localObserver.pvPoint)
                                }
                            }

                            if (tv) {
                                localObserver.tvPoint = Math.trunc(Math.min(Math.max((tv.value * 100) / tv.requiredValue, 0), 100))
                                if (localObserver.tvPoint >= 100) {
                                    localObserver.tvPoint = 100
                                } else {
                                    localObserver.tvPoint = Math.floor(localObserver.tvPoint)
                                }
                            }

                            if (afp) {
                                localObserver.afpPoint = Math.trunc(Math.min(Math.max((afp.value * 100) / afp.requiredValue, 0), 100))
                                if (localObserver.afpPoint >= 100) {
                                    localObserver.afpPoint = 100
                                } else {
                                    localObserver.afpPoint = Math.floor(localObserver.afpPoint)
                                }
                            }
                        })
                    }
                })
            }
        })

        return () => {
            disposer()
        }
    }, [])

    return (
        <Stack gap={2} alignItems={'center'}>
            <Stack direction={'row'} gap={'12px'}>
                <CompleteBox title="PV" bgColor="rgba(47, 128, 237, 1)" point={localObserver.pvPoint} />
                <CompleteBox title="TV" bgColor="rgba(187, 107, 217, 1)" point={localObserver.tvPoint} />
                {StoreAchievement.getSelectedRank() === 'DIA2' && <CompleteBox title="AFP" bgColor="rgb(249, 135, 165)" point={localObserver.afpPoint} />}
            </Stack>
            <Stack direction={'row'} gap={'12px'}>
                <CompleteBox title="Leg 1" bgColor="rgba(242, 153, 74, 1)" point={localObserver.leg1Point} />
                <CompleteBox title="Leg 2" bgColor="rgba(242, 201, 76, 1)" point={localObserver.leg2Point} />
                <CompleteBox title="Leg 3" bgColor="rgba(183, 226, 80, 1)" point={localObserver.leg3Point} />
            </Stack>
        </Stack>
    )
})

export default CompleteBoxes
